module.exports = __webpack_public_path__ + "img/face_nor@2xx.ce98987d.png";